import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDashboardAccess } from '../../api/useDashboardAccess';
import Loading from '../../components/Loading';
import DashboardPanel from './components/DashboardPanel';
import { DashboardContextProvider } from './DashboardContext';
import { DashboardFiltersContextProvider } from './components/filters/DashboardFiltersContext';

const DashboardRootPage = () => {
    const { hasDashboardAccess, isLoading } = useDashboardAccess();

    const urlParams = new URLSearchParams(window.location.search);
    const returnToBackoffice = urlParams.get('backoffice');

    const redirectUrl = returnToBackoffice
        ? `${process.env.REACT_APP_LINK_BACK_OFFICE}Pages/Reporting/Dashboard.aspx`
        : '/transactions';

    if (isLoading) {
        return <Loading />;
    }

    if (!hasDashboardAccess) {
      if (returnToBackoffice) {
          window.location.replace(redirectUrl);
          return null;
      }

      return <Navigate to="/transactions" replace />;
    }

    return (
        <DashboardContextProvider>
            <DashboardFiltersContextProvider>
                <DashboardPanel />
            </DashboardFiltersContextProvider>
        </DashboardContextProvider>
    );
};

export default DashboardRootPage;
